/**
 * aria wiring for a field that may carry a <FieldError id={errorId}>. Extra
 * ids (a PasswordPolicyHint, say) stay in aria-describedby either way.
 */
export function invalidFieldProps(errorId, message, ...describedBy) {
    const ids = [message ? errorId : null, ...describedBy].filter(Boolean).join(' ');
    return {
        'aria-invalid': message ? true : undefined,
        'aria-describedby': ids || undefined,
    };
}
/**
 * Where focus goes after a client-side validation failure.
 *
 * With a mouse and keyboard: onto the first invalid field (screen readers then
 * read its error through aria-describedby).
 *
 * On a touch-first device: nowhere. iOS/iPadOS keep the on-screen keyboard up
 * after "Go", and it covers the bottom of the page, including the inline error
 * under the focused field and the toast. Blurring drops the keyboard so both
 * show; the invalid field is scrolled into view in case it sits above the fold.
 */
export function revealInvalidField(field) {
    const touchFirst = typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;
    if (!touchFirst) {
        field?.focus();
        return;
    }
    const active = document.activeElement;
    if (active instanceof HTMLElement)
        active.blur();
    field?.scrollIntoView?.({ block: 'nearest' });
}
